import {
  DialogPositioningBehavior,
  DialogProps,
  DialogType,
  DialogWidget,
  HorizontalOriginOption,
  VerticalOriginOption,
} from '@tableau/widgets';
import React from 'react';
import { Messages } from '../../../../../gen-src/Localize';
import { DataQualityDetailPanelSide, getTooltipAnchorClientRect } from '../dataQualityIndicators/DataQualityIndicatorSharedHelpers';
import {
  DataQualityDetailContentStyle,
  DataQualityDetailGroupSpacerDiv,
  DataQualityDetailPanelDialogBodyStyle,
  DataQualityDetailPanelDialogStyle,
} from '../style/DataQualityStyles';
import { DataQualityDetailProps } from './DataQualityDetail';
import { DataQualityDetailGroup } from './DataQualityDetailGroup';

/**
 * @deprecated TFS-1478812
*/
export type DataQualityDetailContentProps = {
  readonly details: ReadonlyArray<DataQualityDetailProps>;
  readonly linksDisabled?: boolean;
}

/**
 * @deprecated TFS-1478812
*/
export type DataQualityDetailPanelProps = DataQualityDetailContentProps & {
  readonly title: string;
  readonly anchorEl?: HTMLElement;
  readonly onCloseRequest: () => void;
  readonly side: DataQualityDetailPanelSide;
  readonly stackingRootId?: string;
}

/**
 * TODO: note that this needs to be refactored to use the unified style "RenderAssetsIndicators"
 */
/**
 * @deprecated TFS-1478812
*/
export function DataQualityDetailContent(props: DataQualityDetailContentProps) {
  const anchoredWarnings: DataQualityDetailProps[] = [];
  const upstreamWarnings: DataQualityDetailProps[] = [];

  for (const warning of props.details) {
    if (warning.onContentItem) {
      anchoredWarnings.push(warning);
    } else {
      upstreamWarnings.push(warning);
    }
  }

  const renderSpacer =
    anchoredWarnings.length > 0 && upstreamWarnings.length > 0;

  return (
    <div style={DataQualityDetailContentStyle}>
      <DataQualityDetailGroup
        keyPrefix={'anchored'}
        details={anchoredWarnings}
        message={Messages.DataQualityContainerAnchored()}
        linksDisabled={props.linksDisabled || false}
      />
      {renderSpacer && <DataQualityDetailGroupSpacerDiv />}
      <DataQualityDetailGroup
        keyPrefix={'upstream'}
        details={upstreamWarnings}
        message={Messages.DataQualityContainerUpstream()}
        linksDisabled={props.linksDisabled || false}
      />
    </div>
  );
}

/**
 * @deprecated TFS-1478812
*/
export function DataQualityDetailPanel(
  props: DataQualityDetailPanelProps
): JSX.Element {
  const dialogProps: DialogProps = {
    title: props.title || '',
    getAnchorClientRect: () => getTooltipAnchorClientRect(props.anchorEl),
    positioningBehavior: DialogPositioningBehavior.Anchored,
    dialogStyle: DataQualityDetailPanelDialogStyle,
    dialogBodyStyle: DataQualityDetailPanelDialogBodyStyle,
    anchorOrigin: {
      vertical: VerticalOriginOption.top,
      horizontal:
        props.side === 'right'
          ? HorizontalOriginOption.right
          : HorizontalOriginOption.left,
    },
    showFooter: false,
    shouldAdjustPositionOnWindowResize: true,
    testId: 'data-quality-detail-panel',
    isModal: true,
    isGlassTransparent: true,
    type: DialogType.Uber,
    showCloseButton: false,
    handleGlassClick: props.onCloseRequest,
    onCloseRequest: props.onCloseRequest,
    shouldReturnFocusOnClose: false,
    disableAutoFocus: true,
    stackingRootId: props.stackingRootId,
  };

  const anchoredWarnings: DataQualityDetailProps[] = [];
  const upstreamWarnings: DataQualityDetailProps[] = [];

  for (const warning of props.details) {
    if (warning.onContentItem) {
      anchoredWarnings.push(warning);
    } else {
      upstreamWarnings.push(warning);
    }
  }

  const renderSpacer =
    anchoredWarnings.length > 0 && upstreamWarnings.length > 0;

  return (
    <DialogWidget {...dialogProps}>
      <DataQualityDetailGroup
        keyPrefix={'anchored'}
        details={anchoredWarnings}
        message={Messages.DataQualityContainerAnchored()}
        linksDisabled={props.linksDisabled || false}
      />
      {renderSpacer && <DataQualityDetailGroupSpacerDiv />}
      <DataQualityDetailGroup
        keyPrefix={'upstream'}
        details={upstreamWarnings}
        message={Messages.DataQualityContainerUpstream()}
        linksDisabled={props.linksDisabled || false}
      />
    </DialogWidget>
  );
}
